import  { 	CARGAR_ITEMS_PLANILLA_DEPCHEQUE, ACTUALIZARSELECCION_CHEQUESDISTRIBUIDOS,
			CARGAR_PLANILLA_DEPCHEQUE, CARGAR_CUENTASBANCARIAS, CARGAR_PLANILLAS_DEPCHEQUE } from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../../actions/generales/actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';

export const cargar_PlanillaDepositoCheque = (codPlanillaDepCheque) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/planillasdepositocheque/' + codPlanillaDepCheque
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let itemsPlanillaDepCheque = response.data;
			dispatch({
				type: CARGAR_ITEMS_PLANILLA_DEPCHEQUE,
				data: itemsPlanillaDepCheque
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar planilla depósito cheque', mensaje: msgError}
			});
		});
	}
}

export const cargar_PlanillasDepositoCheque = (fechaDesde, fechaHasta) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: `/planillasdepositocheque?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {			
			dispatch({
				type: CARGAR_PLANILLAS_DEPCHEQUE,
				data: response.data
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar Planillas Depósito Cheque', mensaje: msgError}
			});
		});
	}
}

export const inicializar_PlanillasDepositoCheque = () =>{
	return {
		type: CARGAR_PLANILLAS_DEPCHEQUE,
		data: []
	}
}

export const actualizarChequesSeleccionadosEnDistribucion = (chequesSeleccionadosEnDistrib) =>{
	return {type: ACTUALIZARSELECCION_CHEQUESDISTRIBUIDOS,
			data: chequesSeleccionadosEnDistrib};
};

export const cargar_PlanillaDepositoChequeDistrib = (codPlanillaDepCheque) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/distribucionesdepositocheque/' + codPlanillaDepCheque
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let planillaDepChequeDistrib = response.data;
			dispatch({
				type: CARGAR_PLANILLA_DEPCHEQUE,
				data: planillaDepChequeDistrib
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar distribución de planilla depósito cheque', mensaje: msgError}
			});
		});
	}
}

export const cargar_CtasBancariasPorDistribPlanillaDeposito = (idPlanillaDep) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/distribucionesdepositocheque/' + idPlanillaDep + '/cuentasdeposito/'
		}
		return global_axios(config_request)
		.then( response => {
			let ctasBancarias = response.data;
			dispatch({
				type: CARGAR_CUENTASBANCARIAS,
				data: ctasBancarias
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;			
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar cuentas bancarias de distribución de planilla depósito cheque', mensaje: msgError}
			});
		});
	}
}

export const cargar_DetalleChequesPlanillaDeposito = (idPlanillaDep, estadoChequesEnPlanilla, loteDepCheque) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/planillasdepositocheque/' + idPlanillaDep + '/cheques?status=' + estadoChequesEnPlanilla + '&lotedepcheque=' + loteDepCheque,
		}
		return global_axios(config_request)
		.then( response => {
			let detChequesPorPlanilla = response.data;
			dispatch({
				type: CARGAR_ITEMS_PLANILLA_DEPCHEQUE,
				data: detChequesPorPlanilla
			})
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;			
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar cheques de planilla depósito cheque', mensaje: msgError}
			});
		});
	}
}